import { IOptionsWithTypes, Room } from '@eventr/common'
import { useMemo } from 'react'
import { cardTranslation } from '../../../i18n/translateHelpers'
import { useScreenTypeContext } from '../../state/screenTypeProvider'
import { useObjectContext } from '../providers/objectProvider'
import { CardText } from '../subComponents/cardText'
import { ChatButton } from '../subComponents/chatButton'
import { EditButton } from '../subComponents/editButton'
import { ExpandableSection } from '../subComponents/expendableSection'
import { HotelCheckInTimes } from './checkInCheckOut'
import { HotelAttachments } from './hotelAttachments'
import { HotelGuests } from './hotelGuests'
import { HotelRoomInfo } from './hotelRoomInfo'
import { ProviderButton } from './providerButton'

interface IHotelBookingInfoProps {
    room?: Room
    attachments?: {
        notes?: string
        extra_docs?: string
        website?: string
        phoneNumber?: string
        contactName?: string
    }
    rooms?: Room[]
    chatNames: string[]
    providerData?: any
}
export const HotelBookingInfo = ({
    room,
    attachments,
    rooms,
    chatNames,
    providerData,
}: IHotelBookingInfoProps) => {
    const { screenType } = useScreenTypeContext()
    const { _id, sectionID } = useObjectContext()
    const mid = useMemo(() => {
        return <CardText>{cardTranslation('Booking Information')}</CardText>
    }, [])

    const allGuests = useMemo(() => {
        const all: IOptionsWithTypes[] = []
        rooms?.forEach((room) => {
            all.push(...(room?.guests ?? []))
        })
        return all
    }, [rooms])

    const end = useMemo(() => {
        if (screenType === 'edit')
            return <EditButton path={`/edit/Section/${sectionID}/${_id}`} />

        return <ChatButton _id={_id} users={allGuests} names={chatNames} />
    }, [screenType, allGuests, _id, chatNames, sectionID])
    return (
        <ExpandableSection mid={mid} end={end}>
            <>
                {room && ['personal', 'upNext'].includes(screenType) && (
                    <HotelRoomInfo
                        bookingRef={room.booking_ref}
                        extra_docs={room.documents}
                        notes={room.comments}
                        roomType={room.roomType}
                    />
                )}
                {room && ['personal'].includes(screenType) && (
                    <HotelCheckInTimes
                        checkInTime={room.checkIn || ''}
                        checkOutTime={room.checkOut || ''}
                    />
                )}
                {attachments && (
                    <HotelAttachments
                        phoneNumber={attachments.phoneNumber}
                        notes={attachments.notes}
                        extra_docs={attachments.extra_docs}
                        website={attachments.website}
                        contactName={attachments.contactName}
                    />
                )}
                {providerData && <ProviderButton providerData={providerData} />}
                {room && ['personal', 'upNext', 'teamMember'].includes(screenType) && (
                    <HotelGuests rooms={[room]} />
                )}
                {rooms && ['team', 'edit'].includes(screenType) && (
                    <HotelGuests rooms={rooms} withDate />
                )}
            </>
        </ExpandableSection>
    )
}
